import {
  EnumerationEvaluationOptionDto,
  EvaluationParameterDto,
  instanceOfEnumerationEvaluationParameterDto,
  TrackItTaskResultForEvaluation,
  TrackItTaskResultForEvaluationDoubleTypeEnum,
  TrackItTaskResultForEvaluationOptionTypeEnum,
} from '@/api/generator';

export type TrackItManualValue = number | EnumerationEvaluationOptionDto;

export function buildTrackItTaskResultForEvaluation(
  evaluation: EvaluationParameterDto,
  value: TrackItManualValue | null,
): TrackItTaskResultForEvaluation {
  if (instanceOfEnumerationEvaluationParameterDto(evaluation)) {
    return {
      evaluationParameterId: evaluation.id,
      optionId: (value as EnumerationEvaluationOptionDto | null)?.id ?? undefined,
      $type: Object.values(TrackItTaskResultForEvaluationOptionTypeEnum)[0],
    };
  }
  return {
    evaluationParameterId: evaluation.id,
    value: value as number | null,
    $type: Object.values(TrackItTaskResultForEvaluationDoubleTypeEnum)[0],
  };
}
